import { useFormContext } from 'react-hook-form';

import type { InvoiceBatchFilterSchema } from './invoice-batch-filter-schema';

export const useInvoiceBatchFilterFormContext = () => {
  const context = useFormContext<InvoiceBatchFilterSchema>();
  return context;
};
